<template>
    <div class="card">
        <div class="card-body">
            <validation-observer v-slot="{ passes, invalid }">
                <form @submit.prevent="passes(save)">
                    <div class="row">
                        <div class="col-5">
                            <!-- <div class="ml-auto d-flex align-items-center">
                                <span class="mr-3 d-none d-sm-block">Serie:</span>
                                <g-field
                                    v-model="fields.serie"
                                    :app="app"
                                    :item="id"
                                    name="serie"
                                    placeholder="XXX-XXX-XXX"
                                    :clean="true"
                                    class="mb-0"
                                />
                            </div> -->

                            <h4 class="text-primary mb-0">
                                <fa-icon v-if="fields.serie_r" :icon="['fas', 'qrcode']" class="mr-2" />
                                <a-tooltip v-else placement="right">
                                    <template slot="title">
                                        <fa-icon :icon="['fas', 'triangle-exclamation']" class="mr-2" />
                                        El gasto no está asociado a una serie existente.
                                    </template>

                                    <fa-icon :icon="['fas', 'triangle-exclamation']" class="mr-2 text-warning" />
                                </a-tooltip>

                                <g-inline-editor v-model="fields.serie" @input="unlinkSerie" />

                                <a-tooltip placement="right">
                                    <template slot="title">
                                        <fa-icon icon="sync-alt" :spin="loadingSerial" />
                                        {{ loadingSerial ? 'Refrescando...' : 'Refrescar nº de serie' }}
                                    </template>
                                    <sup
                                        class="ml-2 font-size-14 cursor"
                                        :class="loadingSerial ? 'text-muted' : 'text-primary'"
                                        @click="loadSerialNumber('GASTOS')"
                                    >
                                        <fa-icon icon="sync-alt" :spin="loadingSerial" />
                                    </sup>
                                </a-tooltip>
                            </h4>
                        </div>

                        <div class="col-7 d-flex">
                            <div class="ml-auto d-flex align-items-center">
                                <span class="mr-3 d-none d-sm-block">F.Factura:</span>
                                <g-field
                                    v-model="fields.bill_date"
                                    :app="app"
                                    :item="id"
                                    name="bill_date"
                                    placeholder="Fecha"
                                    :clean="true"
                                    class="mb-0"
                                />
                                <span class="ml-3 mr-3 d-none d-sm-block">F.Albaran:</span>
                                <g-field
                                    v-model="fields.invoice_date"
                                    :app="app"
                                    :item="id"
                                    name="invoice_date"
                                    placeholder="Fecha"
                                    :clean="true"
                                    class="mb-0"
                                />
                            </div>
                        </div>
                    </div>

                    <hr class="mb-4 mt-3" />

                    <div class="row align-items-center mt-5">
                        <div class="col col-sm-8 mt-sm-0 mt-5 expenseForm">
                            <fieldset class="dashed m-t-20">
                                <label><i class="zmdi zmdi-account-circle" /> Información del Proveedor</label>

                                <div class="providerStatus">
                                    <a-tag v-if="!isProviderSelected"> Sin registrar </a-tag>
                                    <a-tag v-else color="green">
                                        {{ provider_data.name }}
                                        <fa-icon class="ml-1" :icon="['fas', 'times']" @click="resetProvider" />
                                    </a-tag>
                                </div>

                                <div class="row mb-3">
                                    <div class="col">
                                        <g-field
                                            v-model="fields.provider"
                                            :app="app"
                                            :item="id"
                                            type="relation"
                                            table="providers"
                                            name="legal_name"
                                            placeholder="Proveedor"
                                            ret-label="legal_name"
                                            :clean="true"
                                            @input="onProviderChange"
                                        />
                                    </div>
                                </div>

                                <div class="row mb-3">
                                    <div class="col-8">
                                        <g-field
                                            v-model="provider_data.address"
                                            :app="app"
                                            :item="id"
                                            name="provider_address"
                                            placeholder="Dirección"
                                            :clean="true"
                                        />
                                    </div>

                                    <div class="col-4">
                                        <g-field
                                            v-model="provider_data.cp"
                                            :app="app"
                                            :item="id"
                                            name="provider_cp"
                                            placeholder="Código Postal"
                                            :clean="true"
                                        />
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                        <g-field
                                            v-model="provider_data.location"
                                            :app="app"
                                            :item="id"
                                            name="provider_location"
                                            placeholder="Población"
                                            :clean="true"
                                        />
                                    </div>
                                    <div class="col">
                                        <g-field
                                            v-model="provider_data.state"
                                            :app="app"
                                            :item="id"
                                            name="provider_state"
                                            placeholder="Provincia"
                                            :clean="true"
                                        />
                                    </div>
                                    <div class="col">
                                        <g-field
                                            v-model="provider_data.country"
                                            :app="app"
                                            :item="id"
                                            name="provider_country"
                                            placeholder="Pais"
                                            :clean="true"
                                        />
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>

                    <div class="mt-2 mb-2 row">
                        <div class="col text-right">
                            <a-button icon="plus" type="primary" @click="createConcept"> Añadir gasto </a-button>
                        </div>
                    </div>

                    <table
                        class="conceptsTable table table-responsive d-sm-table table-hover"
                        :class="{ 'table-striped': !$settings.dark }"
                    >
                        <thead>
                            <th>GASTO</th>
                            <th>CONCEPTO</th>
                            <th>PRECIO</th>
                            <th>CANTIDAD</th>
                            <th>DESCUENTO</th>
                            <th class="text-right">IVA</th>
                            <th class="text-right">TOTAL</th>
                            <th />
                        </thead>

                        <tbody>
                            <tr v-for="(tr, i) in fields.concepts" :key="i" class="pb-3">
                                <td :style="{ 'min-width': '190px' }">
                                    <g-field
                                        v-model="fields.concepts[i].article"
                                        ret-label="name"
                                        ret-key="_EntityId"
                                        :app="app"
                                        :item="id"
                                        :sync="false"
                                        type="relation"
                                        :name="'gasto'"
                                        table="goods"
                                        label="name"
                                        placeholder="Articulo"
                                        :clean="true"
                                        :filter="goodsFilter"
                                        @input="articleChange($event, i)"
                                    />
                                </td>
                                <td :style="{ 'min-width': '100px' }">
                                    <g-field
                                        v-model="fields.concepts[i].text"
                                        app="concept_expenses"
                                        :item="id"
                                        :name="'text'"
                                        placeholder="Observaciones"
                                        :clean="true"
                                    />
                                </td>
                                <td :style="{ 'min-width': '100px' }">
                                    <g-field
                                        v-model="fields.concepts[i].price"
                                        app="concept_expenses"
                                        :item="id"
                                        :default-value="0"
                                        preffix="€"
                                        :name="'price'"
                                        placeholder="Precio"
                                        :clean="true"
                                    />
                                </td>
                                <td :style="{ 'min-width': '100px' }">
                                    <g-field
                                        v-model="fields.concepts[i].quantity"
                                        app="concept_expenses"
                                        :item="id"
                                        step="1"
                                        :default-value="0"
                                        :name="'quantity'"
                                        placeholder="Cantidad"
                                        :clean="true"
                                    />
                                </td>
                                <td :style="{ 'min-width': '50px' }">
                                    <g-field
                                        v-model="fields.concepts[i].discount"
                                        app="concept_expenses"
                                        :item="id"
                                        :default-value="0"
                                        preffix="%"
                                        :name="'discount'"
                                        placeholder="Descuento"
                                        :clean="true"
                                    />
                                </td>
                                <td class="text-right align-middle" :style="{ 'min-width': '100px' }">
                                    {{ conceptCalculation[i].iva.value | price }} €
                                    <sup>{{ conceptCalculation[i].iva.percent }}%</sup>
                                </td>
                                <td class="text-right align-middle" :style="{ 'min-width': '100px' }">
                                    {{ conceptCalculation[i].total | price }} €
                                </td>
                                <td class="text-center align-middle" :style="{ 'min-width': '50px' }">
                                    <a v-show="i !== '1'" @click="removeConcept(i)">
                                        <fa-icon :icon="['fas', 'times']" />
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="row">
                        <div class="col-12 col-sm-6">
                            <!-- <g-field
								v-model="fields.observations"
								type="textarea"
								:app="app"
								:item="id"
								name="observations"
								placeholder="Observaciones"
								:clean="true"
							/> -->
                        </div>

                        <div class="col-12 col-sm-4 mt-4 mt-sm-0 offset-sm-2 align-self-end">
                            <div class="row">
                                <div class="col-12">
                                    <table class="table table-bordered mb-3">
                                        <tbody>
                                            <tr>
                                                <th class="text-right">SUBTOTAL</th>
                                                <td class="text-right">{{ totalCalculations.subtotal | price }} €</td>
                                            </tr>
                                            <tr>
                                                <th class="text-right">
                                                    IVA <sup>{{ totalCalculations.iva.percent }}%</sup>
                                                </th>
                                                <td class="text-right">{{ totalCalculations.iva.value | price }} €</td>
                                            </tr>
                                            <tr>
                                                <th class="text-right">TOTAL</th>
                                                <td class="text-right">{{ totalCalculations.total | price }} €</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="row mt-3">
                                <div class="col-6 text-left">
                                    <g-field
                                        v-model="fields.payment_method"
                                        :app="app"
                                        :item="id"
                                        name="payment_method"
                                        placeholder="Seleccione metodo de pago"
                                        :clean="true"
                                        class="mb-0"
                                    />
                                </div>
                                <div class="col-6 text-right">
                                    <g-field
                                        v-model="fields.status"
                                        :app="app"
                                        :item="id"
                                        name="status"
                                        placeholder="Seleccione Estado"
                                        :clean="true"
                                        class="mb-0"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="col text-right">
                            <a-button-group>
                                <a-popconfirm
                                    title="¿Estas seguro que deseas resetear el formulario?"
                                    @confirm="() => reset()"
                                >
                                    <a-button> Resetear </a-button>
                                </a-popconfirm>
                                <a-button type="primary" html-type="submit" :loading="loading" :disabled="invalid">
                                    {{ id > 0 ? 'Modificar' : 'Añadir' }}
                                </a-button>
                            </a-button-group>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </div>
    </div>
</template>

<script>
import concepts from './mixins/concepts'
import expenses from './mixins/expenses'
import providers from './mixins/providers'
import calculations from './mixins/calculations'
import series from '@/application/mixins/billing/series'

export default {
    name: 'ExpensesForm',
    mixins: [concepts, expenses, providers, calculations, series],
    async created() {
        // Load events
        this.events(true)
        // Load config
        this.loadConfig()
        // Load expense
        this.load()

        // load new serial number
        if (this.id === 0) {
            await this.loadSerialNumber('GASTOS')
        }
    },
    beforeDestroy() {
        this.events(false)
    },
}
</script>

<style lang="scss">
@import './index.scss';
</style>
